import React, { Fragment, useEffect } from 'react';

export default function (dependencies) {
  const html = (props) => {

    useEffect(() => {
      props.field.state.value = new Date().toISOString();
    }, [])

    return <Fragment></Fragment>

  };
  return {
    html,
    config: {
      invisible: true,
    },
  };
}
